<template>
  <div class="fixed top-4 right-4 z-50 space-y-2">
    <!-- Success Message -->
    <transition name="flash">
      <div 
        v-if="message"
        class="bg-green-50 border border-green-200 rounded-md p-4 shadow-sm max-w-sm"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-green-800">
              {{ message }}
            </p>
          </div>
          <div class="ml-auto pl-3">
            <button
              @click="clearMessage"
              class="inline-flex text-green-400 hover:text-green-600 transition-colors"
            >
              <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Error Message -->
    <transition name="flash">
      <div 
        v-if="error"
        class="bg-red-50 border border-red-200 rounded-md p-4 shadow-sm max-w-sm"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-red-800">
              {{ error }}
            </p>
          </div>
          <div class="ml-auto pl-3">
            <button
              @click="clearError"
              class="inline-flex text-red-400 hover:text-red-600 transition-colors"
            >
              <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { usePage, router } from '@inertiajs/vue3'

const page = usePage()

const message = computed(() => {
  const flash = page.props.flash
  if (flash?.type === 'success') return flash.message
  return flash?.message
})

const error = computed(() => {
  const flash = page.props.flash
  if (flash?.type === 'error') return flash.message
  return flash?.error
})

const clearMessage = () => {
  // Use router.reload() which automatically uses current URL
  router.reload({
    preserveState: true,
    preserveScroll: true,
    only: [],
    onSuccess: () => {
      // Clear flash message
    }
  })
}

const clearError = () => {
  // Use router.reload() which automatically uses current URL
  router.reload({
    preserveState: true,
    preserveScroll: true,
    only: [],
    onSuccess: () => {
      // Clear flash message
    }
  })
}

// Auto-hide messages after 5 seconds
onMounted(() => {
  if (message.value) {
    setTimeout(() => {
      clearMessage()
    }, 5000)
  }
  
  if (error.value) {
    setTimeout(() => {
      clearError()
    }, 7000)
  }
})
</script>

<style scoped>
.flash-enter-active, .flash-leave-active {
  transition: all 0.3s ease;
}
.flash-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.flash-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>